<template>
    <div class="main-container">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>
        <div style="text-align:left;">
            <b-form-checkbox v-model="show_historical">{{ $t('text.show_old_bookings') }}</b-form-checkbox>
        </div>
        <table v-if="isSmallScreen">
            <tr>
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
                <th @click="setOrderBy('start_date')">{{ $t('text.dates') }}</th>
                <th @click="setOrderBy('notes')">{{ $t('text.message') }}</th>
            </tr>
            <tr class="info-row" v-for="booking in bookings" :key="booking.id">
                <td>{{ booking.getCabin() }}</td>
                <td>{{ booking.getStartDateString() }} <br> {{ booking.getEndDateString() }}</td>
                <td>{{ booking.notes }}</td>
            </tr>
        </table>

        <table v-if="!isSmallScreen">
            <tr>
                <th @click="setOrderBy('cabin')">{{ $t('text.cabin') }}</th>
                <th @click="setOrderBy('start_date')">{{ $t('text.dates') }}</th>
                <th @click="setOrderBy('created')">{{ $t('text.created') }}</th>
                <th @click="setOrderBy('notes')">{{ $t('text.message') }}</th>
            </tr>
            <tr class="info-row" v-for="booking in bookings" :key="booking.id" @click="bookingClicked(booking)">
                <td>{{ booking.getCabin() }}</td>
                <td>{{ booking.getStartDateString() }} <br> {{ booking.getEndDateString() }}</td>
                <td>{{ booking.getCreatedDateString() }}</td>
                <td>{{ booking.notes }}</td>
            </tr>
        </table>

        <b-pagination
            style="text-align:center;width:100%;margin-top:16px;"
            align="center"
            v-model="current_page"
            :total-rows="rows"
            :per-page="per_page"
            aria-controls="my-table"
        ></b-pagination>

    </div>
</template>

<script>
import BookingApiService from "../../services/booking_api_service";
import Booking from "../../models/booking";

export default {
    name: "ProfileBookingComponent",
    data() {
        return {
            loading: false,
            bookings: [],
            show_historical: false,
            order_by: '-start_date',
            per_page: 10,
            current_page: 1,
            rows: 0,
            windowWidth : window.innerWidth
        };
    },
    watch: {
        current_page: function() {
            this.fetchBookings();
        },  
        show_historical: function() {
            this.current_page = 1;
            this.fetchBookings();
        },  
        order_by: function() {
            this.current_page = 1;
            this.fetchBookings();
        },  
    },
    computed: {
        isSmallScreen() {
            return this.windowWidth < 980;
        }
    },
    methods: {
        async fetchBookings() {
            this.loading = true;
            var params = (
                "order_by=" + this.order_by + 
                "&only_mine=true" +
                "&show_historical=" + (this.show_historical ? "true" : "false")
            )
            try {
                const data = await BookingApiService.get(this.current_page, params);
                this.rows = data.data.count
                this.bookings = data.data.results.map(dict => {
                    return new Booking(dict);
                });
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        setOrderBy(string) {
            if (string == this.order_by) {
                this.order_by = string.includes('-') ? string : '-'+string
            } else {
                this.order_by = string
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        bookingClicked(booking) {
            this.$router.push({path: "/booking-confirmation", query: { uuid: booking.uuid }})
        }
    },
    created() {
        this.fetchBookings();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    }
};
</script>

<style scoped>
.main-container {
    overflow: visible;
    background-color: transparent;
    padding-bottom: 40px;
}

table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    border-radius: 8px;
    color: #495057;
    table-layout: fixed;
}

td, th {
    text-align: center;
    padding: 8px;
    height:80px;
    white-space: nowrap;
    overflow:hidden;
}

th:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

.info-row:hover {
    background-color: #cee4ff;
    cursor: pointer;
}

tr:nth-child(even) {
    background-color: #e7f2ff;
}


</style>
